import { commercialConfig } from "@/config/storeConfig";

export const formatBRL = (value: number): string =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(value);

export const installmentText = (value: number, times: number): string =>
  `${times}x de ${formatBRL(value / times)} sem juros`;

export const discountThreshold = commercialConfig.discount.threshold;
export const discountRate = commercialConfig.discount.rate;

export const calcDiscount = (subtotal: number): number => {
  if (!commercialConfig.discount.enabled) return 0;
  return subtotal >= discountThreshold ? subtotal * discountRate : 0;
};